module.exports = __webpack_public_path__ + "media/images/service/s_1-160b759faaafb36cc5b6b3efc8859e8a.png";